
export enum StreamerRoles {
  Teacher = 'Teacher',
  Student = 'Student'
}
